import { Badge } from '@/components';
import type { UserRoleApi } from '../models';

export interface UserRolesProps {
  userRoles?: UserRoleApi[] | null;
}

export default function UserRoles({ userRoles }: UserRolesProps) {
  if (userRoles === undefined || userRoles === null) {
    return (
      <p className='mt-2 text-sm text-gray-500'>
        No se encontraron roles.
      </p>
    );
  }

  if (userRoles.length === 0) {
    return <p className='mt-2 text-sm text-gray-500'>Sin roles</p>;
  }

  return (
    <div className='mt-2 flex flex-wrap gap-2'>
      {userRoles.map((userRole) => (
        <div
          key={userRole.id}
          className='flex min-w-0 max-w-full flex-col gap-1'
        >
          <Badge
            value={userRole.role.description}
            showBall={false}
            backgroundColor='#F9FAFB'
            textColor='#374151'
          />
        </div>
      ))}
    </div>
  );
}
